export function formatJMD(cents) {
  const value = (cents || 0) / 100;
  return "J$" + value.toLocaleString("en-JM", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function totalStock(product) {
  return (product?.sizes || []).reduce((s, x) => s + (x.stock || 0), 0);
}

export function isSoldOut(product) {
  return totalStock(product) <= 0;
}

export function salePriceCents(cents, percent) {
  return Math.round((cents || 0) * (1 - (percent || 0) / 100));
}
